import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { slideInAnimation } from 'src/app/core/models/animations';

@Component({
  selector: 'app-spotlight',
  templateUrl: './spotlight.component.html',
  styleUrls: ['./spotlight.component.css'],
  animations: [
    slideInAnimation
    // animation triggers go here
  ]
})
export class SpotlightComponent implements OnInit {

  isSecondarySideNavOpen: boolean;
  constructor(public router: Router) {}

  ngOnInit(): void {
  }

  updateSecondarySideNavStatus($event: any): void {
    // 
    this.isSecondarySideNavOpen = $event;
  }

  prepareRoute(outlet: RouterOutlet): any {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }
}
